export const HowItWorks = () => {
  const steps = [
    {
      number: "1",
      title: "Set up your page",
      description: "Create your page, tell your story, explain your plans and set your fundraising target.",
    },
    {
      number: "2",
      title: "Spread the word",
      description: "Tell everyone you know about your project – friends, colleagues and your community.",
    },
    {
      number: "3",
      title: "Get funded",
      description: "Supporters donate or pledge money towards your project, helping to reach your target.",
    },
  ];

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-gradient-to-b from-background via-primary/5 to-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 max-w-7xl">
        <div className="text-center mb-12 sm:mb-16 space-y-4">
          <div className="inline-flex items-center gap-3 mx-auto">
            <span className="h-px w-8 bg-primary/60" />
            <span className="text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-primary">
              How it works
            </span>
            <span className="h-px w-8 bg-primary/60" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight leading-[1.1] text-foreground">
            Three steps,{" "}
            <span className="font-serif italic font-medium text-primary">from idea</span>{" "}
            to funded.
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
            No spreadsheets, no setup calls — just a fundraising page that goes live the same day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {steps.map((step) => (
            <div
              key={step.number}
              className="group relative bg-card rounded-2xl p-6 sm:p-7 lg:p-8 border-2 border-border hover:border-primary/50 shadow-card hover:shadow-xl hover:-translate-y-1 transition-all duration-300 overflow-hidden"
            >
              <div className="pointer-events-none absolute -top-10 -right-10 w-32 h-32 rounded-full bg-primary/20 blur-2xl opacity-50 group-hover:opacity-80 transition-opacity" />
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="relative flex-shrink-0">
                  <div className="absolute inset-0 -m-1.5 rounded-2xl bg-primary/30 blur-lg opacity-70" />
                  <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-primary/90 to-emerald-500/80 rotate-6" />
                  <div className="relative w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-gradient-to-br from-primary/95 to-emerald-500/90 ring-1 ring-primary/20 shadow-lg flex items-center justify-center text-white text-lg sm:text-xl font-bold group-hover:scale-105 group-hover:-rotate-3 transition-transform">
                    {step.number}
                  </div>
                </div>
                <div className="relative flex-1 min-w-0">
                  <h3 className="text-lg sm:text-xl font-bold text-foreground mb-2 sm:mb-3">
                    {step.title}
                  </h3>
                  <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
